import React from "react";

/**
 * FloatingSuggestions - AI suggestions overlay component
 * Displays floating suggestion bubbles and specs
 */
const FloatingSuggestions = ({
	suggestions = [],
	specs = [],
	hasUserInteracted = false,
}) => {
	if (suggestions.length === 0 && specs.length === 0) {
		return null;
	}

	return (
		<>
			{/* Floating orange specs - behind everything */}
			<div
				className={`pointer-events-none absolute inset-0 z-[4] overflow-hidden ${
					hasUserInteracted ? "animate-fade-out-quickly" : ""
				}`}
			>
				{specs.map((spec) => (
					<div
						key={spec.id}
						className={`absolute rounded-full opacity-70 ${
							spec.color === "green"
								? "bg-gradient-to-br from-green-400 to-emerald-500 shadow-[0_0_8px_rgba(74,222,128,0.6)]"
								: spec.color === "blue"
									? "bg-gradient-to-br from-blue-400 to-blue-600 shadow-[0_0_8px_rgba(59,130,246,0.6)]"
									: "bg-gradient-to-br from-orange-400 to-amber-500 shadow-[0_0_8px_rgba(251,146,60,0.6)]"
						}`}
						style={{
							left: `${spec.left}%`,
							bottom: "-20px",
							width: `${spec.size}px`,
							height: `${spec.size}px`,
							animation: `float-up-smooth 12s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards`,
							animationDelay: `${spec.delay}s`,
						}}
					/>
				))}
			</div>

			{/* Floating suggestion bubbles - in front of specs */}
			<div
				className={`pointer-events-none absolute inset-0 z-[5] overflow-hidden ${
					hasUserInteracted ? "animate-fade-out-quickly" : ""
				}`}
			>
				{suggestions.map((suggestion) => (
					<div
						key={suggestion.id}
						className="absolute"
						style={{
							left: `calc(${suggestion.left}% - ${suggestion.left * 0.7}vw)`,
							bottom: "-60px",
							animation:
								"float-up-smooth 15s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards",
							width: "70vw",
							maxWidth: "280px",
						}}
					>
						<div
							className={`rounded-3xl border-2 px-3 py-2 text-center text-xs font-semibold leading-tight text-white backdrop-blur-sm sm:px-4 sm:py-2.5 sm:text-sm ${
								suggestion.isGrateful
									? "border-green-300/60 bg-gradient-to-br from-green-400/95 to-emerald-500/95 shadow-[0_8px_20px_rgba(74,222,128,0.5)]"
									: "border-orange-300/60 bg-gradient-to-br from-orange-400/95 to-amber-500/95 shadow-[0_8px_20px_rgba(251,146,60,0.5)]"
							}`}
							style={{
								textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
								wordWrap: "break-word",
								overflowWrap: "break-word",
							}}
						>
							{suggestion.text}
						</div>
					</div>
				))}
			</div>
		</>
	);
};

export default FloatingSuggestions;
